import {Link} from 'react-router-dom';
import {ArrowLeftOutlined} from '@ant-design/icons';

import TabCard from '../../components/ui/TabCard/TabCard';
import {pageTabConfig} from './configs/pageTables/pageTabConfig';

const ProposalsPendingPage = ({
    das,
    data,
    filterDealList,
    tableType,
    userData,
    setDasKey,
    dasKey,
    handleGetData,
    handleMissionNavigation,
    tableLoading,
    paginationMetadata
}) => {
    const tableConfig = {handleMissionNavigation, filterDealList, tableType, userData, dasKey, handleGetData, tableLoading, paginationMetadata};

    const handleChangeDasKey = (das) => {
        setDasKey(das.label === "Cabinet" ? '' : das.label);
    }

    return (
        <>
            <div className='flex items-center justify-between pt-10 pb-5'>
                <Link to='/dashboard/codev'>
                    <ArrowLeftOutlined style={{fontSize: '25px'}}/>
                </Link>
                <h1
                    className='text-3xl font-bold'
                    style={{fontFamily: 'DIN Condensed'}}
                >
                    {`Propositions en attente (${paginationMetadata.totalItems})`}
                </h1>
                <div/>
            </div>

            <TabCard config={pageTabConfig(data, "deals", das, tableConfig)} onChange={handleChangeDasKey}/>
        </>
    )
}

export default ProposalsPendingPage;
